import React from 'react';
import { Link } from 'react-router-dom';
import { MapPin, Twitter, Linkedin, Youtube } from 'lucide-react';
import { footerLinks } from '../mock';

// Map link labels to internal routes; anything not in this map stays a placeholder.
const linkRoutes = {
  'Pricing': '/pricing',
  'How it works': '/#how',
  'Free heatmap': '/#audit',
  'Privacy policy': '/privacy',
  'Terms of service': '/terms',
  'Cookie policy': '/privacy#cookies',
  'Do not sell my info': '/privacy#never-sold',
};

const Footer = () => {
  return (
    <footer className="bg-stone-900 text-stone-300 pt-16 pb-8">
      <div className="max-w-[1300px] mx-auto px-6 lg:px-10">
        <div className="grid md:grid-cols-6 gap-8 pb-12 border-b border-stone-800">
          <div className="md:col-span-2">
            <Link to="/" className="flex items-center gap-2">
              <span className="w-9 h-9 rounded-xl bg-[#F97316] flex items-center justify-center">
                <MapPin size={18} className="text-white" strokeWidth={2.5} />
              </span>
              <span className="text-[22px] font-extrabold text-white" style={{ fontFamily: 'Plus Jakarta Sans' }}>Ambanji</span>
            </Link>
            <p className="mt-4 text-[14px] leading-relaxed text-stone-400 max-w-xs">
              An AI teammate for your Google Business Profile. Watches the map, drafts the work, and relays it into your CRM via Ambanji Relay.
            </p>
            <div className="mt-5 flex gap-2">
              {[Twitter, Linkedin, Youtube].map((Icon, i) => (
                <a key={i} href="#" className="w-9 h-9 rounded-lg bg-stone-800 hover:bg-[#F97316] flex items-center justify-center transition-colors">
                  <Icon size={16} />
                </a>
              ))}
            </div>
          </div>

          {Object.entries(footerLinks).map(([title, links]) => (
            <div key={title}>
              <h4 className="text-[12px] font-bold uppercase tracking-widest text-white mb-4">{title}</h4>
              <ul className="space-y-2.5">
                {links.map((link) => {
                  const route = linkRoutes[link];
                  const isInternal = route && route.startsWith('/');
                  return (
                    <li key={link}>
                      {isInternal ? (
                        <Link to={route} className="text-[14px] text-stone-400 hover:text-white transition-colors">
                          {link}
                        </Link>
                      ) : (
                        <a href={route || '#'} className="text-[14px] text-stone-400 hover:text-white transition-colors">
                          {link}
                        </a>
                      )}
                    </li>
                  );
                })}
              </ul>
            </div>
          ))}
        </div>

        <div className="pt-8 flex flex-col md:flex-row items-start md:items-center justify-between gap-4">
          <div>
            <p className="text-[13px] text-stone-500">
              © {new Date().getFullYear()} Crystal Blue Marketing LLC. All rights reserved.
            </p>
            <p className="text-[12px] text-stone-600 mt-1">
              501 Westmoor Pl, Columbus, OH 43204 · Ambanji is a service of Crystal Blue Marketing LLC.
            </p>
          </div>
          <p className="text-[13px] text-stone-500">support@ambanji.com</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
